import { useState } from "react";
import { NavLink } from "react-router-dom";
import { FaBars, FaTimes, FaPhoneAlt } from "react-icons/fa";
import logo from "../assets/logo-with-backgroud.png";

export default function Header() {
  const [open, setOpen] = useState(false);

  const navItems = [
    { name: "Home", path: "/" },
    { name: "About", path: "/about" },
    { name: "Contact", path: "/contact" },
    { name: "FAQ", path: "/faq" },
  ];

  const handlePhoneClick = () => {
    if (window.gtag) {
      window.gtag("config", "AW-18343552397/3FAKCIr6l9ccEI3L8apE", {
        phone_conversion_number: "1-877-991-0909",
      });
    }
  };

  return (
    <header className="sticky top-0 z-50 bg-white shadow-sm border-b">
      <div className="max-w-[1700px] mx-auto px-4 sm:px-6 lg:px-8 xl:px-10 py-3 lg:py-4">
        <div className="grid grid-cols-[auto_1fr_auto] items-center gap-6">
          {/* Logo */}
          <div className="justify-self-start">
            <NavLink to="/">
              <img
                src={logo}
                alt="USA Car Booking"
                className="h-10 sm:h-12 md:h-14 lg:h-16 xl:h-[72px] w-auto object-contain transition-transform duration-300 hover:scale-105"
              />
            </NavLink>
          </div>

          {/* Center Navigation */}
          <div className="hidden lg:flex justify-center">
            <nav className="flex items-center rounded-full border border-gray-200 bg-white p-1 shadow-sm">
              {navItems.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.path}
                  className={({ isActive }) =>
                    `rounded-full px-5 xl:px-7 py-3 text-sm xl:text-base font-semibold transition-all duration-300 ${
                      isActive
                        ? "bg-[#08275C] text-white shadow-md"
                        : "text-[#08275C] hover:bg-slate-100"
                    }`
                  }
                >
                  {item.name}
                </NavLink>
              ))}
            </nav>
          </div>

          {/* Right */}
          <div className="justify-self-end hidden lg:flex items-center gap-4">
            <a
              href="tel:+18779910909"
              onClick={handlePhoneClick}
              className="hidden xl:flex items-center gap-3 rounded-full border border-gray-300 px-6 py-3 text-sm xl:text-base font-semibold text-[#08275C] transition-all duration-300 hover:border-[#08275C] hover:shadow-md"
            >
              <FaPhoneAlt />
              <span>1-877-991-0909</span>
            </a>

            <button className="rounded-full bg-[#EF3B22] px-6 xl:px-8 py-3 text-sm xl:text-base font-bold text-white shadow-[0_10px_25px_rgba(239,59,34,.35)] transition-all duration-300 hover:-translate-y-0.5 hover:scale-105 hover:bg-[#D9351F]">
              RESERVE A CAR
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="justify-self-end lg:hidden">
            <button
              onClick={() => setOpen(!open)}
              className="rounded-lg p-2 text-2xl text-[#08275C] transition-transform duration-300 hover:scale-110"
            >
              {open ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <div
        className={`overflow-hidden bg-white transition-all duration-500 ease-in-out lg:hidden ${
          open ? "max-h-[500px]" : "max-h-0"
        }`}
      >
        <div className="border-t px-5 py-5 space-y-2">
          {navItems.map((item) => (
            <NavLink
              key={item.name}
              to={item.path}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `block rounded-xl px-5 py-4 font-semibold transition-all duration-300 ${
                  isActive
                    ? "bg-[#08275C] text-white"
                    : "text-[#08275C] hover:bg-slate-100"
                }`
              }
            >
              {item.name}
            </NavLink>
          ))}

          <a
            href="tel:+18779910909"
            className="mt-4 flex items-center justify-center gap-3 rounded-xl border border-gray-300 py-4 font-semibold text-[#08275C]"
          >
            <FaPhoneAlt />
            1-877-991-0909
          </a>

          <button className="mt-3 w-full rounded-xl bg-[#EF3B22] py-4 font-bold text-white transition-all duration-300 hover:bg-[#D9351F]">
            RESERVE A CAR
          </button>
        </div>
      </div>
    </header>
  );
}
